import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";



import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";

class WorkSection extends React.Component {
  render() {
       const { classes } = this.props;

    return (
      <div className={classes.section}>
        <div className={classes.container}>
           <GridContainer justify="center">
          <GridItem cs={12} sm={12} md={8} className={classes.marginAuto}>
             
             <h2 className={classes.title}> About Us </h2>
            <h4 className={classes.description}>
            Myanmar is the last untapped market with fastest growing economy in Asia.
             We decided to be part of Myanmar's momentum and aim to deliver right and comprehensive solutions introducing new ideas and services to businesses, individuals and government agencies. 
             We provide complete Engineering Design, Technical Solutions and Consultancy for Architectural, Civil & Structural, Mechanical & Electrical, Information & Communications Technology, 
             and Oil & Gas service sectors.Myanmar Gateway Engineering & Consultancy (MGEC)
              was established with energetic and experienced group of professionals in their associated technical disciplines to fulfil the rising demand of engineering businesses in Myanmar. Skills,
               quality, knowledge and attitude, integrity, collaboration and trust are our core values to achieve great performance at MGEC. We focus on customers’ needs and offer reliable, affordable,
                sustainable, practical and perfect solutions harnessing different ideas from our team of professionals with diverse backgrounds.  We take a consistent approach for each and every project ensuring 
                our proposal is technically feasible and economically justifiable. We strongly believe our expertise will be of an added value to achieve strong and sustainable economic growth thereby improving the 
                lives of all our people in Myanmar.
            </h4>
          
            </GridItem>
      </GridContainer>
      </div>
      </div>
    );
  }
}

export default withStyles(workStyle)(WorkSection);



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/Sections/WorkSection.jsx